<template>
  <div style="width: 100%; height: 100%">
    <!-- 容器整体的部局 -->
    <div class="preview-box">
      <!--header-->
      <div
        v-if="!isFullScreen"
        class="preview-box-header"
      >
        <co-tips
          class="item"
          :content="$t('返回到预览界面')"
          placement="right"
        >
          <span
            class="go-back"
            @click="goFilePreview"
          />
        </co-tips>
        <div class="title-section">
          <span
            v-if=" pageFile.version"
            class="fi fi-version"
          >{{ pageFile.version }}</span><!--
                 --><span class="fi fi-user">{{ pageFile.user }}</span><!--
                 --><span class="fi-time-op"> {{ pageFile.modified | formatTime }} {{ $t(formatOp(pageFile.op)) }}</span>
        </div>
        <div class="button-section"
             v-if="!headerButtonDisabled"
        >
          <button
            v-if="!pageFile.isNow"
            class="cp lv-bn lv-80 lv-rm-12 c-btn"
            @click="setNowVersion"
          >
            {{ $t('设为最新') }}
          </button>
          <button
            v-if="btnDownloadRight"
            class="cp lv-bn lv-80 lv-rm-12 c-btn"
            @click="privateDownloadFile"
          >
            {{ $t('下载') }}
          </button>
          <!--<button
            v-if="isShowppt"
            class="cp lv-bn lv-80 lv-rm-12 c-btn"
            @click="isSideMode = !isSideMode"
          >
            {{ isSideMode? $t('预览模式'):$t('幻灯片模式') }}
          </button>-->
        </div>
      </div>

      <!--body-->
      <div
        class="preview-box-body clearfix"
        :style="{height: isFullScreen?'100%':'calc(100% - 50px)' }"
      >
        <!--preview body-->
        <div
          ref="previewBodyMain"
          :class="['preview-box-body-main']"
          :style="{width: displayRightPanel? 'calc(100% - 300px)' : '100%'}"
        >
          <!--preview-->
          <div
            class="preview-main-iframe"
            :style="{height:isShowFoot && isShowToolBar()?'calc(100% - 50px)':'100%'}"
          >
            <!-- 正常预览 -->
            <bs-switch
              v-if="!abnormalType"
              ref="preview"
              :is-side-mode="isSideMode"
              @loadFail="loadFail"
            />
            <!-- 异常预览提示 -->
            <bs-normal
              v-else
              :data="fileData"
              :type="abnormalType"
              :abnormal-data="abnormalData"
              @abnormal="abnormal"
            />
          </div>

          <!--toolbar-->
          <div
            v-show="isShowFoot && isShowToolBar()"
            ref="previewMainFooter"
            class="section-control"
            @mousemove="footMouseMove"
          >
            <!-- 中间控制预览的操作区域 -->
            <bs-pdftoolBar
              ref="pdftoolbar"
              :data="curFileInfo"
              :doc-check="docCheck"
              @presentationMode="presentationMode"
            />
          </div>
        </div>

        <!--right panel-->
        <div
          v-show="displayRightPanel"
          ref="hlist"
          class="preview-box-body-right"
        >
          <bs-verlist
            ref="versionList"
            :meta-data="curFileInfo"
            @preCurFile="versionPreview"
            @syncDesc="syncDesc"
          />
        </div>
      </div>
    </div>

    <!--dialog-->
    <co-dialog
      v-model="dialog.isShow"
      :is-cancel-left="dialog.isCancelLeft"
      :class="dialog.noPadding"
      :title="dialog.title"
      :width="dialog.width"
      :height="dialog.height"
    >
      <component
        :is="componentName"
        v-if="dialog.isShow"
        ref="signComment"
        :version-data="pageFile"
      />

      <div
        slot="button"
        class="dialog-footer clearfix"
      >
        <button
          class="cp lv-bn lv-80 c-btn f-r"
          @click="dialog.isShow = !dialog.isShow"
        >
          {{ $t('取消') }}
        </button>
        <button
          class="cp lv-bn lv-80 lv-rm-12 s-btn f-r"
          @click="sureConfirm"
        >
          {{ $t(dialog.sureButton) }}
        </button>
      </div>
    </co-dialog>

    <!--confirm-->
    <co-confirm
      v-model="confirm.isShow"
      :title="confirm.title"
      :content="confirm.content"
      :sure-btn="confirm.sureButton"
      :only-one="confirm.onlyOne"
      :is-describe="confirm.isDescribe"
      @sure="sureConfirm"
    />

    <!--toast-->
    <co-toast
      v-model="toast.isShowToast"
      :toast-info="toast.message"
    />

    <!--审批组件-->
    <bs-approval
      ref="bsapproval"
      :other-data="apporvalData"
    />
  </div>
</template>
<script>

import coDoc from 'components/common/doc/index.vue'
import bsSwitch from 'components/business/switch/index.vue'
import bsPic from 'components/business/pic/index.vue'
import bsPdftoolBar from 'components/business/pdftoolbar/index.vue'
import coConfirm from 'components/common/confirm/index.vue'
import coToast from 'components/common/toast/index.vue'
import bsCommentEl from 'components/business/verlist/comment.vue'
import coDialog from 'components/common/dialog/index.vue'
import bsVerlist from 'components/business/verlist/index.vue'
import coTips from 'components/common/tips/index.vue'
import bsNormal from 'components/business/abnormal/index.vue'
import {
  formatDate, isClient, _DOC_PERVIEW_PATH, getPreviewType,
} from 'js/util/util.js'
import { bsFileDownLoad } from 'js/api/download/download'
import _$ from 'js/api/getdata.js'
import { PREVIEW } from 'js/mixin/common.js'
import isExistPolicy from '../business/approval/request-approval'
import bsApproval from 'components/business/approval/request-approval.vue'

export default {
  components: {
    coDoc,
    bsSwitch,
    bsPic,
    bsPdftoolBar,
    bsVerlist,
    bsCommentEl,
    coConfirm,
    coDialog,
    coToast,
    coTips,
    bsNormal,
    bsApproval,
  },
  filters: {
    /**
             * 格式化时间
             */
    formatTime(value) {
      return formatDate(value, 'yyyy-MM-dd hh:mm')
    },
  },
  /**
         * 主要混入的函数
         * showFoot
         * footMouseMove
         * pushEsc
         * checkfull
         * loadFail
         */
  mixins: [PREVIEW],
  data() {
    return {
      curFileInfo: {},
      pageFile: {}, // 当前页面的file对象
      neid: '', // 当前文件neid
      rev: '', // 当前文件的rev版本
      displayRightPanel: true, // 显示右侧布局
      componentName: 'bsCommentEl',
      isConfirm: false, // confirm显隐
      isSideMode: false, // 是否是幻灯片模式
      abnormalType: '',
      isShowFoot: true, // 是否显示底部操作栏
      // 是否显示弹框
      dialog: {
        isShow: false,
        width: '450',
        height: '83',
        title: '',
        sureButton: '添加',
        isCancelLeft: false,
      },
      confirm: { // 确认操作弹窗
        title: '',
        content: '',
        isShow: false,
        sureButton: '确认',
        onlyOne: false,
        isDescribe: false,
      },
      toast: {
        isShowToast: false,
        message: {
          info: '',
          tipsType: 'success',
        },
      },
      abnormalData: { // 超限异常所需的max size
        maxSize: 0,
      },
      apporvalData: {}, // 发起审批
      paramOther: {},
      headerButtonDisabled: true,
    }
  },
  computed: {
    /**
             * 是否为客户端
             */
    isClient() {
      return isClient()
    },
    /**
             * 查看说明添加说明
             */
    fileExplainName() {
      if (Object.keys(this.pageFile).length > 0) {
        if (this.pageFile.comment != '' && this.pageFile.comment != undefined) {
          return this.$t('查看说明')
        }
        return this.$t('添加说明')
      }
    },
    /**
             * 显示ppt预览
             */
    isShowppt() {
      if (Object.keys(this.curFileInfo).length > 0) {
        return /ppt|dps/i.test(this.curFileInfo.mime_type) && !this.isClient
      }
    },
    /**
             * 当前选中文件的信息
             */
    fileData() {
      return this.curFileInfo
    },
  },
  watch: {
    /**
             * 切换换灯片模式的预览
             */
    isSideMode(n, o) {
      this.$store.commit('GET_IS_SIDEMODE', n)
      this.$refs.preview.init()
    },
  },
  created() {
    // 获取浏览器参数
    const { neid, nsid } = this.$route.params
    this.from = this.$route.query.from
    this.neid = neid
    this.nsid = nsid
    this.rev = this.$route.query.rev || ''
    this.paramOther = JSON.parse((this.$route.query && this.$route.query.other) || '{}')
  },
  async mounted() {
    window.addEventListener('message', this.viewError, false)
    // 请求历史版本数据
    this.getVersionList()
  },
  methods: {
    /**
             * 异常报错
             */
    viewError(e) {
      if (e && e.data === 'pdfLoadError') { // 监听到pdf报错信息，调用异常组件
        this.abnormalType = 'loadFail'
      }
    },
    /**
             * 现在当前预览的文件,下载
             */
    downNowRevFile() {
      const downFile = { isDir: false, content: [this.curFileInfo] }
      bsFileDownLoad(downFile)
    },
    /**
     * 私有：下载
     */
    privateDownloadFile() {
      const { neid, nsid, path } = this.fileData
      // 查询是否有审批认证后进行下载
      isExistPolicy({ neid, nsid, path }, 'download').then(() => {
        this.downNowRevFile()
      }).catch((error) => {
        if (error.data) {
          if (error.data.length === 0) {
            this.toast.message.info = this.$t('该审批规则没有审批者，请联系管理员')
            this.toast.message.tipsType = 'warn'
            this.toast.isShowToast = true
          } else {
            this.apporvalData = {
              approvalType: 'download',
              approvers: error.data,
              neids: [neid],
              nsid,
              path,
            }
            this.$nextTick(() => {
              this.$refs.bsapproval.show()
            })
          }
        }
      })
    },
    /**
             * 显示更新/恢复/创建
             */
    formatOp(value) {
      const mapSate = {
        create: '创建',
        update: '更新',
        restore: '恢复',
      }
      return mapSate[value] || ''
    },
    // 请求版本历史列表
    getVersionList() {
      const { from, nsid, prefix_neid: prefixNeid, neid } = this.paramOther
      this.$refs.versionList.initRevisionList({ neid, from, nsid, prefix_neid: prefixNeid }, (fileList) => {
        if(!fileList.error) {
          const nowFile = this.rev == '' ? fileList : fileList.filter((item) => item.rev == this.rev)
          // 预览文件
          this.versionPreview(nowFile['0'])
          this.headerButtonDisabled = false // 操作按钮可展示
        } else {
          this.setAbnormalPage(fileList.errormsg)
        }
      })
    },
    /**
             * 预览历史记录数据
             */
    versionPreview(file) {
      // 设置当前文件
      this.pageFile = file
      // 重新设置rev版本
      this.rev = this.pageFile.rev
      // 初始化当前版本文件信息，检查数据是否正常
      this.init()
    },
    /**
             * 修改文件说明
             */
    shwoFieExplain() {
      this.dialog.title = this.$t('版本说明')
      this.componentName = 'bsCommentEl'
      this.dialog.width = '520'
      this.dialog.height = '284'
      this.dialog.sureButton = '确认'
      this.dialog.isShow = true
      // 重写方法
      this.sureConfirm = () => {
        // 定义提交参数
        const data = {
          neid: this.neid,
          rev: this.pageFile.rev,
          op: 'op_comment',
          comment: this.$refs.signComment.comment,
        }
        // 比较修改是否相同
        if (this.pageFile.comment === data.comment) {
          this.dialog.isShow = false
          return
        }
        // 提交修改数据
        _$.postData('updateRevisions', data).then((res) => {
          if (res.status == 200) {
            // 更新版本说明
            this.pageFile.comment = data.comment
            this.pageFile = { ...this.pageFile }
            // 将当前设置数据同步到组件列表内部
            this.$refs.versionList.updateListItem(this.pageFile)
            this.dialog.isShow = false
          }
        }).catch((error) => {
          this.toast.message.info = error.response.data.message
          this.toast.message.tipsType = 'warn'
          this.toast.isShowToast = true
        })
      }
    },
    /**
             * 设置为当前版本
             */
    setNowVersion() {
      this.confirm.title = this.$t('设为最新')
      this.confirm.content = this.$t('确认将{n}版本设为最新版本?', { n: this.pageFile.version })
      this.confirm.sureButton = this.$t('设为最新')
      this.confirm.isShow = true

      // 改写弹窗方法(设置为当前)
      this.sureConfirm = () => {
        const { neid, nsid, prefix_neid: prefixNeid, from, path_type: pathType, path } = this.paramOther
        const data = {
          neid,
          nsid,
          from,
          target_path: path,
          prefix_neid: prefixNeid,
          path_type: pathType,
          rev: this.rev,
        }
        _$.postData('restore', data).then((res) => {
          if (res.status == 200) { // 重新刷新列表
            this.$refs.versionList.initRevisionList({ neid: this.neid }, (fileList) => {
              this.$router.push({
                name: _DOC_PERVIEW_PATH.ver_preview,
                params: { neid: this.neid },
                query: {
                  from: this.from,
                  language: this.language,
                  other: this.$route.query.other,
                  rev: fileList['0'].rev,
                },
              })
              // 请求数据
              this.versionPreview(fileList['0'])
              this.headerButtonDisabled = false // 操作按钮可展示
            }, false)
            this.confirm.isShow = false
            this.toast.message.info = this.$t('已设为最新版本')
            this.toast.isShowToast = true
          }
        }).catch((error) => {
          this.toast.message.info = error.response.data.message
          this.toast.message.tipsType = 'warn'
          this.toast.isShowToast = true
        })
      }
    },
    /**
             * 确认的操作方法
             */
    sureConfirm() {},
    /**
             * 为当前文件设置描述的互动
             */
    syncDesc(file) {
      if (file.rev == this.pageFile.rev) {
        this.pageFile = { ...file }
      }
    },
    /** 返回到预览界面 */
    goFilePreview() {
      if (this.$route.query.rev) delete this.$route.query.rev
      if (this.$route.query.from) delete this.$route.query.from
      this.$router.push({
        name: _DOC_PERVIEW_PATH.file_preview,
        params: {
          neid: this.neid,
          from: this.from,
        },
        query: this.$route.query,
      })
    },
    setAbnormalPage(errorMsg) {
      // 如果是404 说明文件被删了
      const errCfg = {
        403: { type: 'noAccess' }, // 无权限
        404: { type: 'delete' }, // 被删除
        500: { type: 'loadFail' }, // 加载失败
      }
      // 处理错误异常
      const { state } = errorMsg
      this.abnormalType = errCfg[state].type
      this.headerButtonDisabled = true
      if (state === 403 || state === 404) { // 无权限、已删除文件，操作按钮都不展示
        this.displayRightPanel = false
      }
      return false
    },
    /**
             * 初始化预览信息
             * 请求文件信息如果有错出报错页面
             * 如果没错校验是否为大文件
             */
    async init() {
      try {
        const { from, nsid, prefix_neid: prefixNeid } = this.paramOther
        const searhParam = { neid: this.neid, from, nsid, prefix_neid: prefixNeid }
        this.rev != '' ? searhParam.rev = this.rev : ''
        const d = await _$.getData('getMetadata', searhParam)
        this.curFileInfo = d.data
        this.headerButtonDisabled = false
      } catch (e) {
        return this.setAbnormalPage(e.response.data)
      }
      // 查检预览文件是否超限
      const fileLimit = (await this.checkFileLimit()).data
      if (!fileLimit.checkSizeResult) {
        this.abnormalData.maxSize = fileLimit.previewSizeLimit
        this.abnormalType = 'oversize'
        return
      }
      // 调用预览函数,决定组件类型
      if (this.$refs.preview) {
        this.$refs.preview.startPreview(this.curFileInfo)
      }
    },
    /**
             * 检测预览是否超限
             */
    async checkFileLimit() {
      const data = await _$.getData('previewFileLimit', {
        neid: this.neid,
        nsid: this.nsid,
      })
      return data
    },
    isShowToolBar() {
      if (!this.fileData.neid) {
        return false
      }
      const type = getPreviewType(this.fileData) || ''
      return ['doc', 'image'].indexOf(type) != -1 && this.docCheck()
    },
    /**
             * 校验doc档预览
             * 超过文件限制，或者幻灯片模式是否要预览
             */
    docCheck() {
      if (!this.fileData.neid) {
        return false
      }
      return this.fileData.mime_type.indexOf('.xls') === -1 && !this.isSideMode && this.abnormalType != 'oversize'
    },
    /**
             * 异常函数的操作事件
             */
    abnormal(key) {
      const cfg = {
        back: 'goFilePreview', // back to preview
        download: 'downNowRevFile', // download
        refresh: 'refreshPreview', // refresh
      }
      if (cfg[key]) {
        this[cfg[key]]()
      }
    },
    /**
             * failed to load, click 'refresh' to load it again
             */
    refreshPreview() {
      this.abnormalType = '' // 重置异常组件的显示
      this.init()
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/button.less';
@import '~less/box.less';
.dialog-footer {
  padding: 10px 24px;
}
.preview-box{
  .preview-box-header{
    .title-section{
      .fi-version{
        width:38px;
        height:20px;
        background: #0A64FA;
        border-radius: 2px;
        font-size: 12px;
        color: #FFFFFF;
        letter-spacing: 0;
        line-height: 12px;
        padding: 1px 5px;
      }
      .fi {
        margin:0px 6px;
      }
    }
  }
}

.section-control {
  width: 100%;
  height: 50px;
  display: block;
  background-color: #f6f7fa;
  box-shadow: -4px 0 6px 0 rgba(0,0,0,.15);
  position: relative;
}
</style>
